// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.generated';
import { ProductAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { MeleeFragmentDoc } from '../composables/useMelee.generated';
import { ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../components/rings/DeliveryTimeframe.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
import { RelatedProductFragmentDoc } from '../../../components/rings/RelatedProducts.generated';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PageTooltipFragmentDoc } from '../../../components/layout/tooltip/PageTooltip.fragment.generated';
import { SignatureStoneInputFragmentDoc } from '../../../graphql/api/product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const EngagementRingAndSignatureStoneFragmentDoc = gql`
    fragment engagementRingAndSignatureStone on CatalogueEngagementRingAndSignatureStone {
  salePrice(region: $region, currency: $currency) {
    ...taxSnippet
  }
  signatureStone {
    ...signatureStoneInput
    isDefault
    crystal {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    color {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    image
    price(region: $region, currency: $currency) {
      ...money
    }
  }
}
    ${TaxSnippetFragmentDoc}
${SignatureStoneInputFragmentDoc}
${MoneyFragmentDoc}`;
export const EngagementRingPageDocument = gql`
    query engagementRingPage($locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $page: String!, $pageFallback: String!, $engagementRingFilter: CatalogueEngagementRingFilterInput!) {
  catalogueEngagementRing(filter: $engagementRingFilter) {
    ...engagementRingLink
    ...productPageMeta
    ...productGallery
    ...productAnalytics
    meleeItems {
      ...melee
    }
    ...shopWithConfidenceProduct
    noEngravingDeliveryDate: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: false
    ) {
      ...deliveryTimeframe
    }
    hasEngravingDeliveryDate: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    reviews {
      ...reviews
    }
    catalogueCode
    salePrice(region: $region, currency: $currency) {
      ...taxSnippet
    }
    productName
    variationsByCentreStoneShape {
      ...engagementRingLink
      centreStoneConstraints {
        shape {
          systemCode
          translation(locale: $locale) {
            name
          }
          icon {
            id
            url
          }
        }
      }
    }
    variationsByPrimaryMetal {
      ...metalVariation
      ...engagementRingLink
    }
    bandWidth
    relatedProducts {
      ...relatedProduct
    }
    primaryMetal {
      translation(locale: $locale) {
        name
      }
    }
    translation(locale: $locale) {
      seoText
    }
    centreStoneConstraints {
      shape {
        translation(locale: $locale) {
          name
        }
      }
    }
    signatureStone {
      colors {
        systemCode
      }
      crystal {
        systemCode
      }
      width
    }
    signatureStones {
      ...engagementRingAndSignatureStone
    }
  }
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    priceExplainedTooltip {
      ...pageTooltip
    }
  }
}
    ${EngagementRingLinkFragmentDoc}
${ProductPageMetaFragmentDoc}
${ProductGalleryFragmentDoc}
${ProductAnalyticsFragmentDoc}
${MeleeFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${ReviewsFragmentDoc}
${TaxSnippetFragmentDoc}
${MetalVariationFragmentDoc}
${RelatedProductFragmentDoc}
${EngagementRingAndSignatureStoneFragmentDoc}
${BlockFragmentDoc}
${MetaFragmentDoc}
${PageTooltipFragmentDoc}`;

export function useEngagementRingPageQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.EngagementRingPageQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.EngagementRingPageQuery, SchemaTypes.EngagementRingPageQueryVariables | undefined>({ query: EngagementRingPageDocument, variables: undefined, ...options });
};